import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='life-insurance-common-answers-to-1099-faq'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          align='center'>
          Common Answers to 1099 Questions
        </Typography>
        <Accordion
          id='faq-common-1099-faq'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: 'life-insurance-faq-receive-1099-faq',
              title: <>When can I expect to receive my Form 1099&#8211;R or 1099&#45;INT&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  The Internal Revenue Service &#40;IRS&#41; and the Internal Revenue Code &#40;IRC&#41; require Northwestern Mutual mail Form 1099&#8211;R and 1099&#8211;INT to the taxpayer by January 31st &#40;or the next business day if January 31st falls on a weekend or legal holiday&#41; of the year following the year in which the distribution took place or the interest was earned. Example: A reportable transaction occurs by December 31st then a tax form 1099 needs to be sent by January 31st of the following year. Given the large volume
                  of tax forms mailed during January, it may take several days for the form to reach the taxpayer.Form 1099s are also available through the Northwestern Mutual website as early as February 1st
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-access-1099-online-faq',
              title: <>How can I access my 1099 online&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  <Link linkUrl='/log-in/' variant='primaryDeemphasize'>Log into our client website</Link> and select the Documents page from the drop down menu. 1099 documents will be displayed under the document type &#39;Tax Documents&#39;.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-why-am-receving-form-1099-faq',
              title: <>Why am I receiving a Form 1099 from Northwestern Mutual&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    The Internal Revenue Service &#40;IRS&#41; and the Internal Revenue Code &#40;IRC&#41; require Northwestern Mutual to report certain distributions received from life insurance and annuity contracts, and interest earned. The IRS requires that we report this information on a Form 1099 to both the taxpayer and the IRS. Some common examples of taxable income Northwestern Mutual is required to report include:
                  </Typography>
                  <Typography nextElement='typography'>
                    <strong>Form 1099 &#45;INT&#8211;</strong>
                    Interest earned from a Billing Account, interest earned on dividends
                    that are left to accumulate &#40;i.e. Accumulated Dividends&#41;, interest income plans, interest earned on
                    death proceeds after the date of death, but prior to the proceeds being paid, and interest earned on Access Fund Accounts&#59; if the amount of the interest is at least &#36;10.00.
                  </Typography>
                  <Typography nextElement='typography'>
                    <strong>Form 1099&#8211;R, Distributions From Pensions, Annuities, &#8230; Insurance Contracts, etc.</strong>&#8211;Full and partial distributions and certain dividend payments from life insurance and annuity
                    contracts. Note: Certain tax&#45;free exchanges are also reportable on Form 1099&#8211;R for informational
                    purposes.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-faq-tax-advising-faq',
              title: <>Can Northwestern Mutual advise me on tax matters&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  No, Northwestern Mutual cannot provide tax advice as tax laws are complex and circumstances can vary greatly. For tax advice you should consult with your tax advisor.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-issuing-single-1099-form-for-multi-owners-faq',
              title: <>This contract has multiple owners, why was only one 1099 issued&#63;</>,
              contentAs: 'div',
              content: (
                <Typography nextElement='typography'>
                  Northwestern Mutual records that a contract has multiple owners, but we do not have knowledge of the arrangement among the owners of the contract. The IRS specifies that for multiple owners, the reporting company may report to the first owner of record to fulfill its reporting obligation. The first owner of record, in turn, can divide and report the income to the other owners &#40;referred to as &#34;nominees&#34;&#41; on separate Forms 1099 based on their respective ownership interests. If you need to nominate additional owners you may want to consult with your tax advisor or refer to <Link
                    linkUrl="https://www.irs.gov/pub/irs-pdf/i1099gi.pdf" isOutgoingLink variant='primaryDeemphasize'> General Instructions for Certain Information Returns &#40;Forms 1097, 1098, 1099, 3921, 3922, 5498, and W&#45;2G&#41;</Link>.
                </Typography>
              ),
            },
            {
              id: 'life-insurance-faq-download-to-tax-software-faq',
              title: <>Can I download my Northwestern Mutual Form 1099 information directly into my tax preparation software&#63;</>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Currently, Northwestern Mutual does not provide this service for life insurance or annuity products.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);

